import React, { useState, useMemo, useRef, useEffect } from "react";
import SunEditor from "suneditor-react";
import "./offerpagestyle.css";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { getOffers, postOffers, UpdateOffer } from "../auth/service";
import AddIcon from "@mui/icons-material/Add";
import { toast, ToastContainer } from "react-toastify";

export default function OfferPageData() {
  const editorRef = useRef(null);

  const [offers, setOffers] = useState([]);
  const [buttons, setButtons] = useState([]);

  const [showEditor, setShowEditor] = useState(false);
  // const [currentOffer, setCurrentOffer] = useState("");
  const [offerHeading, setOfferHeading] = useState("");
  const [currentOffer, setCurrentOffer] = useState("");

  const [showPopup, setShowPopup] = useState(false);
  const [btnLabel, setBtnLabel] = useState("");
  const [btnLink, setBtnLink] = useState("");
  const [editingOfferIndex, setEditingOfferIndex] = useState(null);
  const [editingButtonIndex, setEditingButtonIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteType, setDeleteType] = useState(""); // "offer" | "button"
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [tempOffers, setTempOffers] = useState([]);
  const [editingTempIndex, setEditingTempIndex] = useState(null);
  const [isEditingMode, setIsEditingMode] = useState(false);
  const [deletingId, setDeletingId] = useState(null);
  const [mainOfferId, setMainOfferId] = useState(null);
  const [tempButtons, setTempButtons] = useState([]);
  const [editingTempButtonIndex, setEditingTempButtonIndex] = useState(null);

  /* ✅ LOCK SCROLL FOR BOTH MODALS */
  useEffect(() => {
    // if (showPopup || showEditor)
    if (showPopup || showEditor || showDeleteModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showPopup, showEditor, showDeleteModal]);

  const editorOptions = useMemo(
    () => ({
      buttonList: [
        ["undo", "redo"],
        ["formatBlock"],
        ["bold", "italic", "underline"],
        ["align", "list"],
        ["link", "table"],
        ["removeFormat"],
      ],
    }),
    [],
  );

  // const handleSaveOffer = () => {
  //   if (!currentOffer.trim()) return;

  //   if (editingOfferIndex !== null) {
  //     // UPDATE
  //     const updated = [...offers];
  //     updated[editingOfferIndex] = currentOffer;
  //     setOffers(updated);
  //     setEditingOfferIndex(null);
  //   } else {
  //     // ADD
  //     setOffers((prev) => [...prev, currentOffer]);
  //   }

  //   setCurrentOffer("");
  //   setShowEditor(false);
  // };

  // const handleSaveOffer = () => {
  //   if (!offerHeading.trim() || !currentOffer.trim()) return;

  //   const newOffer = {
  //     heading: offerHeading,
  //     description: currentOffer,
  //   };

  //   if (editingOfferIndex !== null) {
  //     // UPDATE
  //     const updated = [...offers];
  //     updated[editingOfferIndex] = newOffer;
  //     setOffers(updated);
  //     setEditingOfferIndex(null);
  //   } else {
  //     // ADD
  //     setOffers((prev) => [...prev, newOffer]);
  //   }

  //   // Reset
  //   setOfferHeading("");
  //   setCurrentOffer("");
  //   setShowEditor(false);
  // };

  // const handleSaveOffer = () => {
  //   if (!offerHeading.trim() || !currentOffer.trim()) return;

  //   const newOffer = {
  //     heading: offerHeading,
  //     description: currentOffer,
  //   };

  //   // Save only inside popup list
  //   setTempOffers((prev) => [...prev, newOffer]);

  //   // Reset fields
  //   setOfferHeading("");
  //   setCurrentOffer("");
  // };

  const handleSaveOffer = () => {
    if (!offerHeading.trim() || !currentOffer.trim()) return;

    // ❌ Stop if already 3 offers
    if (editingTempIndex === null && tempOffers.length >= 3) {
      toast.warning("Only 3 offers allowed");
      return;
    }

    const newOffer = {
      heading: offerHeading,
      description: currentOffer,
    };

    if (editingTempIndex !== null) {
      // ✅ UPDATE at same index
      setTempOffers((prev) =>
        prev.map((item, index) =>
          index === editingTempIndex ? newOffer : item,
        ),
      );

      setEditingTempIndex(null);
    } else {
      // ✅ ADD new
      setTempOffers((prev) => [...prev, newOffer]);
    }

    // Reset fields
    setOfferHeading("");
    setCurrentOffer("");
  };

  const handleSubmitOffers = async () => {
    if (offers.length === 0 && buttons.length === 0) {
      alert("Please add at least one offer or button");
      return;
    }

    const payload = {
      offer: offers.map((item) => ({
        heading: item.heading,
        description: item.description,
      })),
      button: buttons.map((btn) => ({
        name: btn.label,
        value: btn.link,
      })),
    };

    try {
      if (mainOfferId) {
        // ✅ UPDATE EXISTING DOCUMENT
        await UpdateOffer(mainOfferId, payload);
        // alert("Offers updated successfully ✅");
        toast.success("Offers updated successfully ");
      } else {
        // ✅ FIRST TIME CREATE
        const res = await postOffers(payload);

        // store new id
        if (res?._id) {
          setMainOfferId(res._id);
        }

        toast.success("Offers created successfully ");
      }

      fetchOffers(); // refresh data from backend
    } catch (error) {
      console.error("API Error:", error);
      alert("Something went wrong ❌");
    }
  };

  const handleSaveButton = () => {
    if (!btnLabel.trim() || !btnLink.trim()) {
      toast.warning("Button label and link are required ⚠️");
      return;
    }

    // ❌ Stop if already 2 buttons
    if (editingTempButtonIndex === null && tempButtons.length >= 2) {
      toast.warning("Only 2 buttons allowed");
      return;
    }

    const newBtn = {
      label: btnLabel,
      link: btnLink,
    };

    if (editingTempButtonIndex !== null) {
      // UPDATE
      setTempButtons((prev) =>
        prev.map((item, index) =>
          index === editingTempButtonIndex ? newBtn : item,
        ),
      );

      setEditingTempButtonIndex(null);
    } else {
      // ADD
      setTempButtons((prev) => [...prev, newBtn]);
    }

    setBtnLabel("");
    setBtnLink("");
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    try {
      const response = await getOffers();

      if (!Array.isArray(response) || response.length === 0) {
        setOffers([]);
        setButtons([]);
        setMainOfferId(null); // no document yet
        return;
      }

      // ⚠️ Assuming you only have ONE offer document
      const mainDoc = response[0];

      setMainOfferId(mainDoc._id); // ⭐ STORE ID HERE

      const formattedOffers = (mainDoc.offer || []).map((offer) => ({
        _id: offer._id,
        heading: offer.heading,
        description: offer.description,
      }));

      const formattedButtons = (mainDoc.button || []).map((btn) => ({
        label: btn.name,
        link: btn.value,
      }));

      setOffers(formattedOffers);
      setButtons(formattedButtons);
    } catch (error) {
      console.error("Error fetching offers:", error);
    }
  };

  const handleEditTempOffer = (index) => {
    const offerToEdit = tempOffers[index];

    setOfferHeading(offerToEdit.heading);
    setCurrentOffer(offerToEdit.description);

    setEditingTempIndex(index); // store index
  };

  const handleConfirmDelete = () => {
    if (deleteType === "offer") {
      setTempOffers((prev) => prev.filter((_, i) => i !== deleteIndex));

      if (editingTempIndex === deleteIndex) {
        setOfferHeading("");
        setCurrentOffer("");
        setEditingTempIndex(null);
      }
    }

    if (deleteType === "button") {
      setTempButtons((prev) => prev.filter((_, i) => i !== deleteIndex));

      if (editingTempButtonIndex === deleteIndex) {
        setBtnLabel("");
        setBtnLink("");
        setEditingTempButtonIndex(null);
      }
    }

    toast.success("Deleted successfully ");

    setShowDeleteModal(false);
    setDeleteIndex(null);
    setDeleteType("");
  };
  return (
    <div className="offer-container">
      <h2 className="offer-title">🎁 Offers</h2>

      {/* ACTION BUTTONS */}
      {/* <button
        className="offer-add-btn"
        onClick={() => {
          setTempOffers([]);
          setIsEditingMode(false); // 🔥 we are adding
          setShowEditor(true);
        }}
      >
        + Add New Offer
      </button> */}

      {/* <button
        className="offer-add-btn"
        onClick={() => {
          setTempOffers(offers); // load saved offers
          setIsEditingMode(true);
          setShowEditor(true);
        }}
      >
        + Add and 👁 View offers
      </button>

      <button
        className="offer-add-btn"
        style={{ marginLeft: "10px" }}
        onClick={() => setShowPopup(true)}
      >
        + Add Button
      </button>

      <button
        className="offer-add-btn"
        style={{ marginLeft: "10px", backgroundColor: "#28a745" }}
        onClick={handleSubmitOffers}
      >
        {isEditingMode ? "Update Offers" : "Save All Offers"}
      </button> */}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "20px",
        }}
      >
        {/* LEFT SIDE BUTTONS */}
        <button
          className="offer-add-btn"
          onClick={() => {
            setTempOffers(offers);
            setIsEditingMode(true);
            setShowEditor(true);
          }}
        >
          + Add and 👁 View offers
        </button>

        <button
          className="offer-add-btn"
          onClick={() => {
            setTempButtons(buttons); // load existing buttons
            setEditingTempButtonIndex(null);
            setBtnLabel("");
            setBtnLink("");
            setShowPopup(true);
          }}
        >
          + Add and 👁 View buttons
        </button>

        {/* RIGHT SIDE BUTTON */}
        <button
          className="offer-add-btn"
          style={{
            marginLeft: "auto",
            backgroundColor: "#28a745",
          }}
          onClick={handleSubmitOffers}
        >
          Update Offers
        </button>
      </div>

      {/* SAVED OFFERS */}
      <div className="offers-list">
        {offers.length > 0 && (
          <div className="offers-header">
            <h3 className="saved-title">Saved Offers</h3>
          </div>
        )}

        <ul className="offer-simple-list">
          {offers.map((offer, index) => (
            <li
              key={index}
              className="offer-list-item"
              style={{ position: "relative" }}
            >
              <strong>{offer.heading}</strong>

              <div
                className="offer-description"
                dangerouslySetInnerHTML={{ __html: offer.description }}
              />

              {/* ACTION ICONS */}
              <div
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  display: "flex",
                  gap: "6px",
                }}
              ></div>
            </li>
          ))}
        </ul>

        {/* SAVED BUTTONS */}

        {buttons.length > 0 && (
          <div style={{ marginTop: "25px" }}>
            <div className="offers-header">
              <h3 className="saved-title">Saved Buttons</h3>
            </div>

            <ul className="offer-simple-list">
              {buttons.map((btn, index) => (
                <li
                  key={index}
                  className="offer-list-item"
                  style={{ position: "relative" }}
                >
                  <strong>{btn.label}</strong>

                  <div className="offer-description">
                    <a
                      href={btn.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#007bff", wordBreak: "break-all" }}
                    >
                      {btn.link}
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* ================= EDITOR MODAL ================= */}

      {showEditor && (
        <div className="modal-overlay" onClick={() => setShowEditor(false)}>
          <div
            className="modal editor-modal button-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Add Offer</h3>
            <input
              className="modal-input"
              placeholder="Offer Heading"
              value={offerHeading}
              onChange={(e) => setOfferHeading(e.target.value)}
            />
            <SunEditor
              getSunEditorInstance={(editor) => {
                editorRef.current = editor;
              }}
              onChange={(content) => setCurrentOffer(content)}
              height="100px"
              setOptions={editorOptions}
              setContents={currentOffer}
            />

            <div className="editor-scroll-section">
              {tempOffers.map((offer, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ddd",
                    padding: "12px",
                    marginBottom: "10px",
                    borderRadius: "6px",
                    background: "#f9f9f9",
                    position: "relative",
                  }}
                >
                  <strong>{offer.heading}</strong>

                  <div
                    style={{ marginTop: "6px" }}
                    dangerouslySetInnerHTML={{ __html: offer.description }}
                  />

                  {/* ACTION ICONS */}
                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "6px",
                      display: "flex",
                      gap: "6px",
                    }}
                  >
                    {/* EDIT */}
                    <Tooltip title="Edit Offer">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => handleEditTempOffer(index)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    {/* DELETE */}
                    <Tooltip title="Delete Offer">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          // setTempOffers((prev) =>
                          //   prev.filter((_, i) => i !== index),
                          // );
                          setDeleteType("offer");
                          setDeleteIndex(index);
                          setShowDeleteModal(true);

                          // if deleting currently edited item, reset form
                          if (editingTempIndex === index) {
                            setOfferHeading("");
                            setCurrentOffer("");
                            setEditingTempIndex(null);
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-actions">
              <button className="btn save-btn" onClick={handleSaveOffer}>
                Save Offer
              </button>

              <button
                className="btn save-btn"
                style={{ backgroundColor: "#28a745" }}
                onClick={() => {
                  if (tempOffers.length === 0) {
                    toast.warning(
                      "Please add at least one offer before saving ⚠️",
                    );
                    return;
                  }

                  setOffers(tempOffers);
                  setTempOffers([]);
                  setShowEditor(false);
                }}
              >
                Save All
              </button>

              <button
                className="btn cancel-btn"
                onClick={() => {
                  setTempOffers([]);
                  setShowEditor(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= BUTTON MODAL ================= */}

      {showPopup && (
        <div className="modal-overlay" onClick={() => setShowPopup(false)}>
          <div
            className="modal editor-modal button-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Add Button</h3>

            <input
              className="modal-input button-modal"
              placeholder="Button Subject"
              value={btnLabel}
              onChange={(e) => setBtnLabel(e.target.value)}
            />

            <input
              className="modal-input button-modal"
              placeholder="Button Href Link"
              value={btnLink}
              onChange={(e) => setBtnLink(e.target.value)}
            />

            <button
              className="btn save-btn button-modal"
              onClick={handleSaveButton}
            >
              {editingTempButtonIndex !== null ? "Update Button" : "Add Button"}
            </button>

            {/* BUTTON LIST INSIDE POPUP */}
            <div className="editor-scroll-section button-modal">
              {tempButtons.map((btn, index) => (
                <div
                  key={index}
                  style={{
                    border: "1px solid #ddd",
                    padding: "12px",
                    marginBottom: "10px",
                    borderRadius: "6px",
                    background: "#f9f9f9",
                    position: "relative",
                  }}
                >
                  <strong>{btn.label}</strong>
                  <p style={{ marginTop: "6px" }}>{btn.link}</p>

                  <div
                    style={{
                      position: "absolute",
                      top: "6px",
                      right: "6px",
                      display: "flex",
                      gap: "6px",
                    }}
                  >
                    {/* EDIT */}
                    <Tooltip title="Edit Button">
                      <IconButton
                        size="small"
                        color="primary"
                        onClick={() => {
                          setBtnLabel(btn.label);
                          setBtnLink(btn.link);
                          setEditingTempButtonIndex(index);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>

                    {/* DELETE */}
                    <Tooltip title="Delete Button">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          // setTempButtons((prev) =>
                          //   prev.filter((_, i) => i !== index),
                          // );
                          setDeleteType("button");
                          setDeleteIndex(index);
                          setShowDeleteModal(true);

                          if (editingTempButtonIndex === index) {
                            setBtnLabel("");
                            setBtnLink("");
                            setEditingTempButtonIndex(null);
                          }
                        }}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </div>
              ))}
            </div>

            <div className="modal-actions">
              <button
                className="btn save-btn"
                style={{ backgroundColor: "#28a745" }}
                onClick={() => {
                  if (tempButtons.length === 0) {
                    toast.warning("Please add at least one button ⚠️");
                    return;
                  }

                  setButtons(tempButtons);
                  setTempButtons([]);
                  setShowPopup(false);
                }}
              >
                Save All
              </button>

              <button
                className="btn cancel-btn"
                onClick={() => {
                  setTempButtons([]);
                  setShowPopup(false);
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
      {/* ========== DELETE CONFIRMATION MODAL ========== */}
      {/* ========== DELETE CONFIRMATION MODAL ========== */}

      {showDeleteModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowDeleteModal(false)}
        >
          <div
            className="modal delete-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>⚠️ Confirm Delete</h3>

            <p style={{ marginTop: "10px" }}>
              Are you sure you want to delete this{" "}
              {deleteType === "offer" ? "offer" : "button"}?
              <br />
              This action cannot be undone.
            </p>

            <div className="modal-actions">
              <button
                className="btn cancel-btn"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>

              <button
                className="btn"
                style={{ backgroundColor: "#dc3545", color: "#fff" }}
                onClick={handleConfirmDelete}
              >
                Yes, Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
